module.exports = __webpack_public_path__ + "images/2966cdceabb1fb7ab1c1441affc67c16.webp";